import { render, staticRenderFns } from "./StandardChartControls.vue?vue&type=template&id=65c6ce39&scoped=true&"
import script from "./StandardChartControls.vue?vue&type=script&lang=js&"
export * from "./StandardChartControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c6ce39",
  null
  
)

export default component.exports